import React, { useEffect, useState, useCallback } from "react";
import { useLocation } from "react-router-dom";
import { Row, Col, Collapse } from "antd";
import { useIntl } from "react-intl";

import Submit from "../submit";
import ColliForm from "../colliForm";
import {
  loadWrappings,
  loadCountries,
  loadCurrencies,
  loadPreselections,
} from "../../../modules/staticDataLoad";
import ServicesForm from "../servicesForm";
import ReferenceForm from "../referenceForm";
import {
  parseAddress,
  loadClientRules,
} from "../../../modules/consignmentFunctions";
import LoadError from "../../app/generic/loadError";
import AddressForm from "../../address/addressForm";
import LoadSkeleton from "../../app/generic/loadSkeleton";
import { getEntities } from "../../../modules/crudOperations";

const { Panel } = Collapse;

const allPanels = ["1", "2", "3", "4"];

export const formItemLayout = {
  labelCol: {
    sm: 5,
    xxl: 4,
  },
  wrapperCol: {
    sm: 16,
    xxl: 12,
  },
  colon: false,
};

function ConsignmentForm({
  edit,
  detail,
  product,
  consignment,
  onLoadConsignment,
}) {
  const intl = useIntl();
  const [colliIcon, setColliIcon] = useState();
  const [pickupIcon, setPickupIcon] = useState();
  const [invoiceIcon, setInvoiceIcon] = useState();
  const [deliveryIcon, setDeliveryIcon] = useState();
  const [servicesIcon, setServicesIcon] = useState();

  const { pathname } = useLocation();
  const [templateWork] = useState(
    (consignment && consignment.templateName) || pathname.endsWith("template")
      ? true
      : false
  );

  const [formCollis, setFormCollis] = useState([]);
  useEffect(() => {
    if (consignment && consignment.collis) {
      setFormCollis(consignment.collis.map((c, i) => ({ ...c, key: i })));
    }
  }, [consignment]);

  const [pickupForm, setPickupForm] = useState();
  const [invoiceForm, setInvoiceForm] = useState();
  const [deliveryForm, setDeliveryForm] = useState();
  const [servicesForm, setServicesForm] = useState();
  const [referenceForm, setReferenceForm] = useState();
  const savePickupFormRef = useCallback((formRef) => {
    setPickupForm(formRef);
  }, []);
  const saveDeliveryFormRef = useCallback((formRef) => {
    setDeliveryForm(formRef);
  }, []);
  const saveInvoiceFormRef = useCallback((formRef) => {
    setInvoiceForm(formRef);
  }, []);
  const saveServicesFormRef = useCallback((formRef) => {
    setServicesForm(formRef);
  }, []);
  const saveReferenceFormRef = useCallback((formRef) => {
    setReferenceForm(formRef);
  }, []);

  const [showInvoiceAddress, setShowInvoiceAddress] = useState(
    consignment && consignment.invoiceAddress && product.domestic
  );

  const [rules, setRules] = useState({});
  const [pickupCountry, setPickupCountry] = useState();
  const [deliveryCountry, setDeliveryCountry] = useState();
  const [carryToFloor, setCarryToFloor] = useState(
    consignment && consignment.services && consignment.services.carryToFloor
  );
  const loadProductData = useCallback(() => {
    loadClientRules(
      product,
      carryToFloor,
      setRules,
      () =>
        setShowInvoiceAddress(
          consignment && consignment.invoiceAddress && product.domestic
        ),
      pickupCountry && pickupCountry.id,
      deliveryCountry && deliveryCountry.id
    );
  }, [product, consignment, carryToFloor, pickupCountry, deliveryCountry]);

  const [chosenPickupId, setChosenPickupId] = useState();
  const [chosenDeliveryId, setChosenDeliveryId] = useState();
  const [chosenInvoiceId, setChosenInvoiceId] = useState();

  const [countries, setCountries] = useState();
  const [wrappings, setWrappings] = useState();
  const [currencies, setCurrencies] = useState();
  const [preselections, setPreselections] = useState();
  const [deliveryCountryCurrencies, setDeliveryCountryCurrencies] = useState();
  const loadStaticFormData = useCallback(() => {
    loadCountries(setCountries);
    loadCurrencies(setCurrencies);
    loadPreselections(setPreselections);
    loadWrappings(setWrappings, product && product.id);
  }, [product]);

  /**
   * pro update formu v případe chyby
   */
  const loadFormData = useCallback(() => {
    loadProductData();
    loadStaticFormData();
  }, [loadProductData, loadStaticFormData]);

  const [depots, setDepots] = useState();
  const loadDepots = useCallback(() => {
    (!depots || depots === "e") &&
      getEntities("depot", setDepots, (c) => ({
        ...c,
        addressInfo: parseAddress(c.address),
      }));
  }, [depots]);

  const [showAll, setShowAll] = useState();
  const [activePanels, setActivePanels] = useState([]);
  const handleCollapseChange = useCallback((keys) => {
    setActivePanels(keys);
  }, []);
  const handleShowAllPanels = useCallback(() => {
    const panels = [...allPanels];
    showInvoiceAddress && panels.push("5");
    setActivePanels(panels);
  }, [showInvoiceAddress]);
  const handleHideAllPanels = useCallback(() => {
    setActivePanels([]);
  }, []);

  useEffect(() => {
    setShowAll(activePanels.length !== (showInvoiceAddress ? 5 : 4));
  }, [activePanels, showInvoiceAddress]);

  useEffect(() => {
    loadProductData();
  }, [loadProductData]);
  useEffect(() => {
    loadStaticFormData();
  }, [loadStaticFormData, intl.locale]);
  const [selectCountries, setSelectCountries] = useState();
  useEffect(
    () =>
      product &&
      countries &&
      countries !== "e" &&
      setSelectCountries(
        product.countries && product.countries.length > 0
          ? product.countries
          : countries
      ),

    [product, countries]
  );

  const [adrCount, setAdrCount] = useState(0);
  useEffect(() => {
    setAdrCount(
      consignment && consignment.services && consignment.services.adr
        ? consignment.services.adr.length
        : 0
    );
  }, [consignment]);

  return (
    <Row type="flex" justify="center" gutter={[0, 100]}>
      <Col sm={24} xxl={18}>
        {selectCountries && wrappings && currencies && preselections ? (
          selectCountries !== "e" &&
          wrappings !== "e" &&
          currencies !== "e" &&
          preselections !== "e" ? (
            <div>
              <ReferenceForm
                showAll={showAll}
                detail={detail}
                ref={saveReferenceFormRef}
                formItemLayout={formItemLayout}
                onShowAllPanels={handleShowAllPanels}
                onHideAllPanels={handleHideAllPanels}
                initialValue={consignment && consignment.customerReference}
              />
              <Row gutter={[0, 50]}>
                <Col>
                  <Collapse
                    activeKey={activePanels}
                    onChange={handleCollapseChange}
                  >
                    <Panel
                      key="1"
                      forceRender
                      header={intl.formatMessage({
                        id: "consignment.pickup",
                        defaultMessage: "Nakládka",
                      })}
                      extra={pickupIcon}
                    >
                      <AddressForm
                        showSearch
                        saveAsCustomer
                        addressType="PC"
                        depots={depots}
                        detail={detail}
                        product={product}
                        countries={countries}
                        loadDepots={loadDepots}
                        ref={savePickupFormRef}
                        domestic={product.domestic}
                        preselections={preselections}
                        formItemLayout={formItemLayout}
                        countriesForSelect={selectCountries}
                        onCountrySelect={setPickupCountry}
                        onSetChosenAddressId={setChosenPickupId}
                        personalDepotId={
                          consignment &&
                          consignment.services &&
                          consignment.services.personalPickupDepotId
                        }
                        address={consignment && consignment.pickupAddress}
                      />
                    </Panel>
                    <Panel
                      key="2"
                      forceRender
                      header={intl.formatMessage({
                        id: "consignment.delivery",
                        defaultMessage: "Vykládka",
                      })}
                      extra={deliveryIcon}
                    >
                      <AddressForm
                        showSearch
                        saveAsCustomer
                        addressType="DL"
                        depots={depots}
                        detail={detail}
                        product={product}
                        countries={countries}
                        loadDepots={loadDepots}
                        ref={saveDeliveryFormRef}
                        preselections={preselections}
                        formItemLayout={formItemLayout}
                        countriesForSelect={selectCountries}
                        onCountrySelect={setDeliveryCountry}
                        onSetChosenAddressId={setChosenDeliveryId}
                        onSetCountryCurrencies={setDeliveryCountryCurrencies}
                        personalDepotId={
                          consignment &&
                          consignment.services &&
                          consignment.services.personalDeliveryDepotId
                        }
                        address={consignment && consignment.deliveryAddress}
                      />
                    </Panel>
                    <Panel
                      key="3"
                      forceRender
                      extra={colliIcon}
                      header={intl.formatMessage({
                        id: "consignment.collis",
                        defaultMessage: "Nákladové kusy",
                      })}
                    >
                      <ColliForm
                        rules={rules}
                        detail={detail}
                        product={product}
                        collis={formCollis}
                        adrCount={adrCount}
                        wrappings={wrappings}
                        onColliSave={setFormCollis}
                        formItemLayout={formItemLayout}
                      />
                    </Panel>
                    <Panel
                      key="4"
                      forceRender
                      header={intl.formatMessage({
                        id: "consignment.services",
                        defaultMessage: "Služby",
                      })}
                      extra={servicesIcon}
                    >
                      <ServicesForm
                        rules={rules}
                        detail={detail}
                        product={product}
                        collis={formCollis}
                        wrappings={wrappings}
                        currencies={currencies}
                        ref={saveServicesFormRef}
                        onSetAdrCount={setAdrCount}
                        templateWork={templateWork}
                        pickupCountry={pickupCountry}
                        deliveryCountry={deliveryCountry}
                        onSetCarryToFloor={setCarryToFloor}
                        onCashTransportPay={setShowInvoiceAddress}
                        deliveryCountryCurrencies={deliveryCountryCurrencies}
                        initialServices={consignment && consignment.services}
                        invoiceAddress={
                          consignment && consignment.invoiceAddress
                        }
                        countOfEuroPallets={
                          consignment && consignment.countOfEuroPallets
                        }
                      />
                    </Panel>
                    {showInvoiceAddress && (
                      <Panel
                        key="5"
                        forceRender
                        header={intl.formatMessage({
                          id: "consignment.invoice",
                          defaultMessage: "Fakturační adresa",
                        })}
                        extra={invoiceIcon}
                      >
                        <AddressForm
                          showSearch
                          onlyAddress
                          saveAsCustomer
                          optionalContact
                          detail={detail}
                          countries={countries}
                          ref={saveInvoiceFormRef}
                          preselections={preselections}
                          formItemLayout={formItemLayout}
                          countriesForSelect={selectCountries}
                          disabledCountrySet={product.domestic}
                          onSetChosenAddressId={setChosenInvoiceId}
                          address={consignment && consignment.invoiceAddress}
                        />
                      </Panel>
                    )}
                  </Collapse>
                </Col>
              </Row>
              <Submit
                edit={edit}
                rules={rules}
                detail={detail}
                product={product}
                adrCount={adrCount}
                wrappings={wrappings}
                formCollis={formCollis}
                pickupForm={pickupForm}
                consignment={consignment}
                invoiceForm={invoiceForm}
                deliveryForm={deliveryForm}
                servicesForm={servicesForm}
                referenceForm={referenceForm}
                templateWork={templateWork}
                setColliIcon={setColliIcon}
                setPickupIcon={setPickupIcon}
                setInvoiceIcon={setInvoiceIcon}
                setServicesIcon={setServicesIcon}
                setDeliveryIcon={setDeliveryIcon}
                chosenPickupId={chosenPickupId}
                chosenDeliveryId={chosenDeliveryId}
                chosenInvoiceId={chosenInvoiceId}
                onHideAllPanels={handleHideAllPanels}
                onLoadConsignment={onLoadConsignment}
                showInvoiceAddress={showInvoiceAddress}
              />
            </div>
          ) : (
            <LoadError
              message={intl.formatMessage({
                id: "messages.formLoadError",
                defaultMessage: "Při načítání formuláře nastala chyba",
              })}
              onClick={loadFormData}
            />
          )
        ) : (
          <LoadSkeleton />
        )}
      </Col>
    </Row>
  );
}

export default ConsignmentForm;
